/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import {
  Container,
  Image,
  Navbar,
  Nav,
  Button,
  Row,
  Col
} from "react-bootstrap";
import { Icon } from "components";

import "./styles.css";
import logo from "assets/comexLogo.png";
import { PAGE_KEY, USER_KEY } from "store/auth";
import useRouter from "util/useRouter";
// import colors from "layouts/colors";

const NavBar = () => {
  const { history } = useRouter();
  const [menus, setMenus] = useState([]);
  const [imgLogo, setImgLogo] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const userInfos = JSON.parse(localStorage.getItem(USER_KEY));



  const changeTitle = title => {
    localStorage.setItem(PAGE_KEY, title);
  };

  const title = tipo => {
    switch (tipo) {
      case 0:
        return "<div>Operações de Câmbio</div>";
      case 1:
        return "<div>Faturas</div>";
      case 2:
        return "<div>Pagamento no Exterior</div>";
      case 3:
        return "<div>Ajuda</div>";
      case 4:
        return "<div>Gestor de Usuários</div>";
      case 5:
        return "<div>ComexWeb</div>";
      case 6:
        return "<div>Meu Perfil</div>";
    }
  };

  return (
    <Container fluid className=" navbar_container">
      <Row>
        <Image
          className="navbar__logo"
          title="Home"
          src={logo}
          onClick={() => {
            changeTitle(title(5));
            history.push("/dashboards");
          }}
        />
      </Row>
      <Row>
        <Button
          id="navbar_options__button"
          href="#/contrato"
          onClick={() => changeTitle(title(0))}
        >
          <Icon name="playlist_add_check" style={{ color: "#006491" }} />
          <div className="navbar_options__button--text">
            Operações de Câmbio
          </div>
        </Button>
        <Button
          id="navbar_options__button"
          href="#/fatura"
          onClick={() => changeTitle(title(1))}
        >
          <Icon name="attach_money" style={{ color: "#006491" }} />
          <div className="navbar_options__button--text">Faturas </div>
        </Button>
        <Button
          id="navbar_options__button"
          href="#/pagex"
          onClick={() => changeTitle(title(2))}
        >
          <Icon name="map" style={{ color: "#006491" }} />
          <div className="navbar_options__button--text">
            Pagamento no Exterior{" "}
          </div>
        </Button>
        <Button
          id="navbar_options__button"
          href="#/meuperfil"
          onClick={() => changeTitle(title(6))}
        >
          <Icon name="assignment" style={{ color: "#006491" }} />
          <div className="navbar_options__button--text">Meu Perfil </div>
        </Button>
        {userInfos.master && (
          <Button
            id="navbar_options__button"
            href="#/management/list"
            onClick={() => changeTitle(title(4))}
          >
            <Icon name="view_comfy" style={{ color: "#006491" }} />
            <div className="navbar_options__button--text">
              Gestor de Usuários{" "}
            </div>
          </Button>
        )}
        <Button
          id="navbar_options__button"
          href="#/ajuda"
          onClick={() => changeTitle(title(3))}
        >
          <Icon name="help_center" style={{ color: "#006491" }} />
          <div className="navbar_options__button--text">Ajuda </div>
        </Button>
      </Row>
    </Container>
  );
};

export default NavBar;
